import validation from '@/libraries/validFormat';
import { mapState, mapGetters } from 'vuex';
import { COURSES } from '@/store/modules/courses/constants';
import { STATES } from '@/store/modules/states/constants';
import { JOB_ROLE } from '@/store/modules/jobrole/constants';
import store from '@/store';
import Actions from '@/libraries/apiActions.js';
import { attachJobParam } from '@/utils/formatJob';
import {
  DEFAULT_JOBS_LIST_DESCRIPTION,
  DEFAULT_JOBS_LIST_KEYWORDS,
} from '@/utils/seo';
import moment from 'moment';

function getBreadcrumbJson() {
  return {
    type: 'application/ld+json',
    json: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: window.location.origin,
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'jobs',
        item: window.location.href,
      }],
    },
  };
}

export default {
  beforeCreate() {
    this.$store = store;
  },
  created() {
    const apiFn = this.action;
    this.cachedDispatch(COURSES.GET_COURSE, { param: apiFn });
    this.cachedDispatch(STATES.GET_STATES, { param: apiFn });
    this.cachedDispatch(JOB_ROLE.GET_JOB_ROLE, { param: apiFn });
  },
  computed: {
    ...mapGetters(['cachedDispatch']),
    ...mapState({
      courses: state => state.courses.courses.courses,
      locations: state => state.states.locations.locations,
      jobrole: state => state.jobrole.jobrole.jobrole,
    }),
    pageTitle() {
      if (this.filterd) {
        let t = '';
        if (this.selectedRole) t += this.selectedRole + ' ';
        t += 'Jobs';
        if (this.selectedLocation) t += ' in ' + this.selectedLocation;
        return t;
      }
      if (this.job_head) return this.job_head;
      if (this.$route.query.redirect_from === 'fresher_jobs') return 'Fresher jobs';
      return 'Latest jobs';
    },
    jobDetailBasePath() {
      return '/jobs/';
    },
  },
  data() {
    return {
      validate: new validation(),
      action: new Actions(),
      jobs: [],
      seo_title: '',
      meta_desc: '',
      meta_keyword: '',
      job_head: '',
      job_subhead: null,
      job_name: '',
      loading: true,
      meta_loading: true,
      no_matching_jobs: false,
      meta: null,
      exp: [
        { value: 1, text: '0 Month(Fresher)' },
        { value: 6, text: '06 Months' },
        { value: 12, text: '1 Year' },
        { value: 24, text: '2 year' },
        { value: 36, text: '3 year' },
        { value: 48, text: '4 year' },
        { value: 60, text: '5 year' },
        { value: 72, text: '6 year' },
        { value: 84, text: '6+ year' },
      ],
      pages: [],
      page: 1,
      length: 0,
      perPage: 25,
      filter: {
        job_role: null,
        city_id: null,
        experience_from: null,
        experience_to: null,
        salary_range_from: null,
        course_id: null,
        search: null,
        offset: 0,
      },
      selectedRole: null,
      selectedLocation: null,
      filterd: false,
      limit: 25,
      job_url: null,
      top_content: null,
      bottom_content: null,
      showDismissibleAlert: false,
      success_msg: null,
      alert_class: null,
      isLogin: false,
      top_readMoreActivated: false,
      bottom_readMoreActivated: false,
      faqs: [],
    };
  },
  beforeMount() {
    this.isLogin = !!(this.$cookies.get('hire-seeker') && this.$cookies.get('hire-seeker').token);
    if (this.isLogin) {
      this.filter.user_id = this.$cookies.get('hire-seeker').id;
    }
    if (Object.keys(this.$route.params).length && this.$route.params.success) {
      this.showDismissibleAlert = true;
      this.success_msg = this.$route.params.success;
      this.alert_class = this.$route.params.status ? 'alert-success' : 'alert-error';
    }

    const path = this.$route.path;
    const isJobsIndex = path === '/jobs' || path === '/jobs/';
    const isJobSearch = path === '/jobsearch';

    if (!isJobsIndex && !isJobSearch) {
      const url = this.$route.params.jobs_list;
      this.action.getJobsByURL(url).then(res => {
        if (res.url.length > 0) {
          this.job_url = res.url[0];
          this.seo_title = this.job_url.seo_title;
          this.meta_desc = this.job_url.meta_description;
          this.meta_keyword = this.job_url.meta_keyword;
          this.meta_loading = false;
          this.job_head = this.job_url.page_head;
          this.job_subhead = this.job_url.page_subhead;
          this.job_name = this.job_url.name;
          this.top_content = this.job_url.top_content;
          this.bottom_content = this.job_url.bottom_content;
          this.faqs = this.job_url.faq;
          this.filter.city_id = (this.job_url.static_id === 1) ? this.job_url.city_id : null;
          this.filter.category_id = (this.job_url.static_id === 4) ? this.job_url.category_id : null;
          this.filter.course_id = (this.job_url.static_id === 2) ? this.job_url.course_id : null;
          this.filter.job_role = (this.job_url.static_id === 3) ? this.job_url.role_id : null;
          this.filter.search = (this.job_url.static_id === 5) ? this.job_url.api_url_parameter.split('=')[1] : null;
          this.action.listJobsByUrl(this.job_url.api_url_parameter).then((listRes) => {
            this.processJobListResponse(listRes);
          });
        } else {
          this.$router.push('/not-found');
        }
      });
    } else {
      this.meta_loading = false;
      this.filter.experience_from = (this.$route.query.redirect_from === 'fresher_jobs') ? this.$route.query.experience_from : null;
      this.filter.experience_to = (this.$route.query.redirect_from === 'fresher_jobs') ? this.$route.query.experience_to : null;
      this.filter.city_id = this.$route.query.city_id ? JSON.parse(this.$route.query.city_id) : null;
      this.filter.course_id = this.$route.query.course_id ? JSON.parse(this.$route.query.course_id) : null;
      this.filter.job_role = this.$route.query.role_id ? JSON.parse(this.$route.query.role_id) : null;
      this.filter.search = this.$route.query.search ? this.$route.query.search : null;
      this.getJobList();
    }
  },
  methods: {
    jobListMetaInfo(vue) {
      const faqData = vue.faqs;
      const meta = [
        { name: 'description', content: vue.meta_desc || DEFAULT_JOBS_LIST_DESCRIPTION },
        { name: 'keywords', content: vue.meta_keyword || DEFAULT_JOBS_LIST_KEYWORDS },
        { property: 'og:title', content: vue.seo_title || 'Job search - Latest fresher govt and mnc job vacancies - Hireclap' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: window.location.href },
        { property: 'og:description', content: vue.meta_desc || DEFAULT_JOBS_LIST_DESCRIPTION },
        { property: 'og:image', content: 'https://d22r5huxahsjvt.cloudfront.net/Assets/images/hireclap-logo-HD.png' },
        { property: 'og:site_name', content: 'hireclap.com' },
      ];
      return {
        title: vue.meta_loading ? '' : (vue.seo_title || 'Job search - Latest fresher govt and mnc job vacancies - Hireclap'),
        meta,
        link: [{ rel: 'canonical', href: process.env.VUE_APP_URL + window.location.pathname.replace('/', '') }],
        script: faqData && faqData.length > 0 ? [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'http://schema.org/',
              '@type': 'FAQPage',
              mainEntity: faqData.map(item => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: { '@type': 'Answer', text: item.answer },
              })),
            },
          },
          getBreadcrumbJson(),
        ] : [getBreadcrumbJson()],
      };
    },
    jobsListPath() {
      return '/jobs';
    },
    jobSearchPath() {
      return '/jobsearch';
    },
    isJobsIndexPath(path) {
      return path === '/jobs' || path === '/jobs/';
    },
    formatJobs(jobs) {
      return jobs.map(job => attachJobParam(job, this.validate, { truncateParam: false }));
    },
    processJobListResponse(res) {
      this.jobs = res.jobs;
      this.meta = res.meta;
      this.limit = res.meta.limit;
      this.filter.offset = res.meta.offset;
      this.length = Math.ceil(res.meta.total / res.meta.limit);
      if (this.jobs.length === 0) {
        this.no_matching_jobs = true;
        this.action.listJobsByUrl('/job_listing?random=true').then((fallback) => {
          this.jobs = this.formatJobs(fallback.jobs);
          this.loading = false;
        });
      } else {
        this.no_matching_jobs = false;
        this.jobs = this.formatJobs(this.jobs);
        this.loading = false;
      }
    },
    setHeader() {
      this.filterd = !!(this.filter.job_role || this.filter.city_id);
      this.jobrole.forEach(ele => {
        if (this.filter.job_role && ele.value === this.filter.job_role) {
          this.selectedRole = ele.text;
        }
      });
      this.locations.forEach(loc => {
        if (loc.id && loc.id === this.filter.city_id) {
          this.selectedLocation = loc.text;
        }
      });
    },
    activateReadMore(type) {
      if (type === 'top') this.top_readMoreActivated = true;
      else this.bottom_readMoreActivated = true;
    },
    calculatePostDate(date) {
      return moment(new Date(date * 1000)).fromNow();
    },
    loadMore() {
      this.filter.offset += this.limit;
      this.action.getJobList(this.filter).then((res) => {
        const more = this.formatJobs(res.jobs);
        this.jobs = this.jobs.concat(more);
        this.limit = res.meta.limit;
        this.filter.offset = res.meta.offset;
      });
    },
    getJobList() {
      this.pages = [];
      this.perPage = 25;
      this.action.getJobList(this.filter).then((res) => {
        this.jobs = this.formatJobs(res.jobs);
        this.meta = res.meta;
        this.limit = res.meta.limit;
        this.filter.offset = res.meta.offset;
        this.length = Math.ceil(res.meta.total / res.meta.limit);
        this.loading = false;
      });
    },
    handleSetRole(role) {
      this.filter.job_role = role.value;
      this.getJobList();
      this.setHeader();
    },
    handleSetExp(item) {
      this.filter.experience_from = item.value;
      this.getJobList();
      this.setHeader();
    },
    handleSetSalary(value) {
      this.filter.salary_range_from = value;
      this.getJobList();
    },
    handleClearSidebarFilter(type) {
      if (type === 'all' || type === 'role') {
        this.filter.job_role = null;
        this.selectedRole = null;
      }
      if (type === 'all' || type === 'exp') {
        this.filter.experience_from = null;
        this.filter.experience_to = null;
      }
      if (type === 'all' || type === 'salary') {
        this.filter.salary_range_from = null;
      }
      this.getJobList();
      if (type === 'salary') return;
      this.setHeader();
    },
    submitFilter(e) {
      if (e && e.preventDefault) e.preventDefault();
      const searchQuery = {};
      if (this.filter.search) searchQuery.search = this.filter.search;
      if (this.filter.course_id) searchQuery.course_id = this.filter.course_id;
      if (this.filter.city_id) searchQuery.city_id = this.filter.city_id;
      if (this.filter.job_role) searchQuery.role_id = this.filter.job_role;

      if (this.isJobsIndexPath(this.$route.path)) {
        this.$router.push({ path: this.jobSearchPath(), query: searchQuery });
        this.getJobList();
        this.setHeader();
      } else {
        this.filter.offset = 0;
        const searchParam = { ...searchQuery };
        if (this.$route.query.redirect_from === 'fresher_jobs') {
          searchParam.redirect_from = 'fresher_jobs';
        }
        if (this.filter.experience_from) searchParam.experience_from = this.filter.experience_from;
        if (this.filter.experience_to) searchParam.experience_to = this.filter.experience_to;
        this.getJobList();
        this.$router.replace({ path: this.jobSearchPath(), query: searchParam });
        this.setHeader();
      }
    },
    clearFilter(e) {
      if (e && e.preventDefault) e.preventDefault();
      this.filter.search = null;
      this.filter.course_id = null;
      this.filter.city_id = null;
      this.filter.job_role = null;
      this.resetFilter();
    },
    resetFilter() {
      if (this.isJobsIndexPath(this.$route.path)) {
        this.$router.push(this.jobsListPath());
      } else if (this.$route.query.redirect_from === 'fresher_jobs') {
        this.$router.push({
          path: this.jobSearchPath(),
          query: { experience_from: 1, experience_to: 12, redirect_from: 'fresher_jobs' },
        });
      } else {
        this.$router.push(this.jobSearchPath());
      }
      location.reload();
    },
  },
};
